module.exports = __webpack_public_path__ + "static/koala-green-8f9b2d761b529294a135340369c531f3.png";